export const StoreMinLength = 2;
export const StoreMaxLength = 150;
export const StoreDebounceTime = 300;
export const StoreControlName = 'Store';
export const StoreLabel = 'Пункт';
export const StorePlaceholder = '';
export const CityClasses = 'form-col w-30';
export const StoreClasses = 'form-col w-70';
